import Modal from '../../modal/Modal';
import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';
import { Category } from '../../api/category';
import { CategoryImageTitle } from './CategoryImageTitle';
import { imageSrc } from '../../api/media';
import { AlertBanner } from '../../components/AlertBanner';
import { Option } from '../../types/option';

type Props = {
    isOpen: boolean;
    category: Category;
    handleClose: () => void;
    handleConfirm: () => void;
    apiError: Option<string>;
};

export function CategoryUnarchiveModal({
    isOpen,
    category,
    handleClose,
    handleConfirm,
    apiError,
}: Props) {
    return (
        <Modal isOpen={isOpen} onClose={handleClose} className="w-full min-h-48">
            <div className="flex flex-col items-center w-full gap-3">
                <ModalHeader>Désarchiver la catégorie</ModalHeader>
                <div className={'mt-5'}>
                    <CategoryImageTitle
                        title={category.title}
                        image={category.media.map(media => imageSrc(media)).getOrElse('')}
                    />
                </div>
                {apiError
                    .map(message => <AlertBanner key="unarchive-error">{message}</AlertBanner>)
                    .toNull()}
                <ModalFooter
                    handlePrimaryAction={handleConfirm}
                    handleSecondaryAction={handleClose}
                    primaryActionTitle={'Restaurer'}
                />
            </div>
        </Modal>
    );
}
